// extracted by mini-css-extract-plugin
export var clauseRow = "_3x-6";
export var emptyState = "_3x-b";
export var filterContent = "_3x-a";
export var filterGroup = "_3x-1";
export var filterGroupContainer = "_3x-0";
export var nestedGroup = "_3x-2";
export var nestedGroupDepth1 = "_3x-3";
export var nestedGroupDepth2 = "_3x-4";
export var nestedGroupDepth3 = "_3x-5";
export var operatorAnd = "_3x-8";
export var operatorOr = "_3x-9";
export var operatorToggle = "_3x-7";
export var removeGroupButton = "_3x-c";